import {ACTION_CODE} from './_actionCode';
import {ContractService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_CONTRACT';

export async function deleteContract(
    userData: Record<string, string>,
    contractId: number
) {
    try {
        LoggerService.logInfo('Action - deleteContract - Start');

        const deleteContractResult = await ContractService.deleteContract(userData, contractId);

        LoggerService.logInfo('Action - deleteContract - End - Success');

        return ResultModel.newSuccessResult(deleteContractResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteContract - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression du contrat.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
